import React from "react";
import { Outlet } from "react-router-dom";
import { RequireOrganisation } from "components/RequireOrganisation";

const Main = () => {
  return (
    <main className="flex min-h-0 grow flex-col overflow-hidden px-4 py-4 sm:px-6 md:px-8">
      <RequireOrganisation>
        <div className="flex min-h-0 min-w-0 flex-1 flex-col">
          <Outlet />
        </div>
      </RequireOrganisation>
    </main>
  );
};

export default Main;
